/*
 * HdCard.tsx
 *
 * Created by Dr. Maximillian Dornseif 2023-11-06 in huWaWi3 33.4.0
 * Copyright (c) 2023 HUDORA GmbH
 */

import { Card, CardContent, Typography } from '@mui/material';
import { Box } from '@mui/system';

export function HdCard({ title, children }) {
  return (
    <Box sx={{ mt: 2, maxWidth: '40vw' }}>
      <Card>
        <CardContent>
          <Typography sx={{ fontSize: '95%' }}>
            <Typography color="text.secondary" gutterBottom variant="h5" component="h3">
              {title}
            </Typography>
            {children}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
